import { ModuleWithProviders }  from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { TimelineComponent } from './timeline/timeline.component';
import { NotFoundComponent } from './notfound/notfound.component';
import { ProjectComponent } from './projects/projects.component';
import { SkillsComponent } from './skills/skills.component';
import { TechnicalComponent } from './technical/technical.component';


const appRoutes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'timeline', component: TimelineComponent },
  { path: 'projects', component: ProjectComponent},
  { path: 'skills', component: SkillsComponent},
  { path: 'technical', component: TechnicalComponent},
  { path: '', component: HomeComponent, pathMatch: 'full'},
  { path: '**', component: NotFoundComponent }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);